import styled, { css, keyframes } from 'styled-components';

import Text from './Text';

const animloader = keyframes`
  0% {
    transform: scale(0);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
`;

const Loader = styled.span`
  width: 56px;
  height: 56px;
  display: inline-block;
  position: relative;
  &:before,
  &:after {
    content: '';
    box-sizing: border-box;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.purpleLighter};
    position: absolute;
    left: 0;
    top: 0;
    animation: ${animloader} 2s linear infinite backwards;
  }
  &:after {
    animation-delay: 1s;
  }
`;

export const LoaderHolder = styled.div<{ $marginBottom?: boolean }>`
  text-align: center;
  padding: 60px;
  background: ${({ theme }) => theme.colors.white};
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 0px 2px 0px #00000014;
  ${({ $marginBottom = true }) =>
    $marginBottom &&
    css`
      margin-bottom: 30px;
    `}
`;

export const LoaderTextHolder = styled.div`
  margin: 0 auto;
`;

export const LoaderTitle = styled(Text)`
  margin-top: 20px;
  margin-bottom: 6px;
`;

const PulsingLoader = () => {
  return <Loader />;
};

export default PulsingLoader;
